<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import type { Track } from '$lib/models/track';
  import Waveform from '$lib/ui/player/waveform.svelte';
  import { player } from '$lib/stores/player';
  import { translation } from '$lib/locale/locale';
  import { timeNormalized, timeToSeconds } from '$lib/utils/time';
  import pauseIcon from '$lib/assets/shared/play/pause-white-no-background.svg';
  import playIcon from '$lib/assets/shared/play/play-white-no-background.svg';
  import downloadIcon from '$lib/assets/shared/download.svg';
  import { AssetType, downloadAsset } from '$lib/utils/asset';
  import Spinner from '$lib/ui/shared/spinner.svelte';
  import type { User } from '$lib/models/user';
  import { showTrialModal } from '$lib/stores/modals';
  import { canDownload } from '$lib/utils/download';
  import { purchaseModal } from '$lib/state/purchase-modal.svelte';

  const { langHref } = translation();

  let {
    asset,
    mainAsset,
    user,
    showDownload = true,
    mainVersion = false,
  }: {
    asset: Track;
    mainAsset: Track;
    user: User | null | void;
    showDownload?: boolean;
    mainVersion?: boolean;
    dark?: boolean;
  } = $props();

  let downloading = $state(false);
  let timer: any;
  let loading = $state(false);

  let playing = $derived($player.id === asset.id && $player.status === 'playing');
  let progress = $derived($player.id === asset.id ? $player.progress : 0);
  let loadingAudio = $derived($player.id === asset.id && $player.status === 'loading');

  function download() {
    if (downloading) return;
    downloading = true;
    loading = true;
    clearTimeout(timer);
    timer = setTimeout(() => {
      loading = false;
      downloading = false;
    }, 10000); // 10 seconds
    downloadAsset(asset).then((response) => {});
  }

  function openSubscriptionModal() {
    showTrialModal.set(true);
  }

  function downloadClick() {
    if (canDownload(mainAsset, user)) {
      download();
    } else if (mainAsset && mainAsset.type == AssetType.Track) {
      purchaseModal.show(mainAsset);
    } else {
      openSubscriptionModal();
    }
  }
</script>

<div class="wave-container">
  {#if loadingAudio}
    <div class="loader">
      <Spinner size="30px" slim={true} />
    </div>
  {:else if playing}
    <button onclick={() => player.pause()} class="play-button">
      <img src={pauseIcon} class="img_charleston-grey" alt={m['actions.pause']()} loading="lazy" />
    </button>
  {:else if !playing && $player.id === asset.id}
    <button onclick={() => player.resume()} class="play-button">
      <img src={playIcon} class="img_charleston-grey play-center" alt={m['actions.play']()} loading="lazy" />
    </button>
  {:else}
    <button onclick={() => player.play(asset, 0, mainAsset)} class="play-button">
      <img src={playIcon} class="img_charleston-grey play-center" alt={m['actions.play']()} loading="lazy" />
    </button>
  {/if}
  {#if mainVersion}
    <div class="title">{m['track-details.main-version']()}</div>
  {:else}
    <div class="title">{asset.title}</div>
  {/if}
  <!-- {#if asset.duration}
    <div class="time">{timeNormalized(asset.duration)}</div>
  {/if} -->
  <div class="wave">
    {#if asset.waveform}
      <Waveform
        data={asset.waveform ?? []}
        {progress}
        height={30}
        marginTop={'0'}
        marginBottom={'0'}
        duration={timeToSeconds(asset.duration)}
        on:seek={(e) => player.play(asset, e.detail)}
      />
    {/if}
  </div>
  {#if showDownload}
    <button onclick={downloadClick} class="download-button" disabled={downloading}>
      <img src={downloadIcon} class="img_text-secondary" alt={m['actions.download']()} loading="lazy" />
    </button>
  {/if}
</div>

<style>
  .wave-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 62px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-primary);
    padding: 16px;
  }

  .title {
    min-width: 269px;
  }

  .wave {
    flex: 1;
    margin-right: 140px;
    margin-left: 24px;
  }

  .play-button {
    width: 30px;
    height: 30px;
    min-width: 30px;
    background-color: #eff0f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }

  .play-button img {
    width: 12px;
    height: 12px;
  }

  .play-center {
    margin-left: 2px;
  }

  .loader {
    width: 30px;
    height: 30px;
    margin-right: 20px;
    display: flex;
  }

  .download-button img {
    width: 24px;
    height: 24px;
  }

  /* .time {
    width: 50px;
    text-align: center;
    margin-left: 24px;
    color: var(--text-invert-secondary);
  } */

  @media (max-width: 1450px) {
    .title {
      min-width: 220px;
    }
  }

  @media (max-width: 900px) {
    .wave {
      display: none;
    }
    .title {
      width: 100%;
    }
    /* .time {
      margin-right: 24px;
    } */
    .wave-container {
      height: 50px;
      padding: 12px;
    }
  }
</style>
